import { HUB_CONNECTION_STATUS } from '../../common/hub-client'
import { MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES } from '../../pages/ManualVerificationPage/models/IManualVerificationPageModel'
import {
  ApplicationActions,
  APPLICATION_CREATED,
  APP_BACK_ONLINE,
  APP_CHANGE_LOADING_SCREEN_TEXT,
  APP_END_LOADING,
  APP_LOADING,
  APP_OFFLINE,
  APP_ONLINE,
  APP_READY,
  BANK_VERIFICATION,
  CHANGE_APPLICATION_STATE,
  CLEAR,
  GET_BM_BANKS,
  PREPARE_APP_REQUEST,
  RETURN_FROM_BM,
  HUB_CONNECTED,
  HUB_DISCONNECTED,
  SET_CONTRACT_DONE_DATA,
  SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION,
  SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE,
  SET_APP_HAS_ERROR,
  SET_USER_TRAPPED_ON_PAGE_URL_PATH,
  SET_HUB_CONNECTION_STATUS,
  SET_USER_EMAIL_FROM_HUB,
  SET_CURRENT_SELECTED_PREDEFINED_PERIOD,
  SET_IS_PREDEFINED_PERIODS_AVAILABLE,
} from "../actions/application-actions";
import { ApplicationState, PREDEFINED_PERIODS_OFFER_LOGIC } from "../types";

export const initialApplicationState: ApplicationState = {
  offert: {
    instalmentAmount: 0,
    instalments: 0,
    loanAmountNet: 0,
    rrso: 0,
  },
  isLoading: true,
  isWaiting: false,
  banks: [],
  billingCompany: "",
  appId: "",
  amountToPay: 0,
  isOffline: false,
  wasOffline : false,
  successReturnUrl: "",
  failureReturnUrl: "",
  waitingScreenText: "",
  kontomatikWidgetClient: "",
  kontomatikWidgetOwnerExternalId: "",
  applicationStatus: "",
  workflowId: null,
  affiliatePartnerIdFromTokenResponse: null,
  isConnected: false,
  isAppHasError: false,
  userTrappedOnPageUrlPath: undefined,
  userEmailFromHub: undefined,
  IS_PREDEFINED_PERIODS_AVAILABLE: false, // [ZAŁOŻENIE BIZNESOWE] DOMYŚLNIE NIE DOSTĘPNE PREDEFINE PERIODS
  currentSelectedPredefinedPeriod: undefined, // [ZAŁOŻENIE BIZNESOWE] DOMYŚLNIE BRAK ZAZNACZONEGO OKRESU
  hubConnectionStatus: {
    status: HUB_CONNECTION_STATUS.DISCONNECTED,
    isConnected: undefined,
    isFinished: undefined,
    isValid: undefined,
    userSessionSessionStorageValue: null,
    error: undefined
  },

  manualVerificationState:  {
    manualVerificationPageHubVerificationState: undefined,
    workFrom: undefined,
    hasClientConsentManualVerification: false,
    clientConsentManualVerificationHasError: false,
    contractDone: {
      clientBankAccountNumber: "",
    }
  }
};
export function applicationReducer(
  state: ApplicationState = initialApplicationState,
  action: ApplicationActions
) : ApplicationState {
  switch (action.type) {
    case APPLICATION_CREATED: {
      return {
        ...state,
        isLoading: false,
        isWaiting: true,
      };
    }
    case CLEAR: {
      return initialApplicationState;
    }
    case CHANGE_APPLICATION_STATE: {
      return {
        ...state,
        isWaiting: action.payload.isWaiting,
        isLoading: false,
      };
    }
    case PREPARE_APP_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case APP_READY: {
      return {
        ...state,
        offert: action.payload.offert,
        billingCompany: action.payload.billingCompany,
        appId: action.payload.appId,
        amountToPay : action.payload.amountToPay,
        isLoading: false,
        successReturnUrl : action.payload.successReturnUrl ?? "",
        failureReturnUrl : action.payload.failureReturnUrl ?? "",
        applicationStatus: action.payload.applicationStatus ?? "",
        workflowId: action.payload.workflowId ?? null,
        affiliatePartnerIdFromTokenResponse: action.payload.affiliatePartnerId,
      };
    }
    case BANK_VERIFICATION: {
      return {
        ...state,
        isWaiting: action.payload.isWaiting,
        isLoading: false,
        kontomatikWidgetClient: action.payload.kontomatikWidgetClient ?? "",
        kontomatikWidgetOwnerExternalId: action.payload.kontomatikWidgetOwnerExternalId ?? "",
      };
    }
    case GET_BM_BANKS: {
      return { ...state, banks: action.payload };
    }
    case RETURN_FROM_BM:{
      return {...state, 
        isWaiting: true, 
      };
    }
    case APP_ONLINE:{
      return {...state, 
        isOffline: false,
      }
    }
    case APP_OFFLINE:{
      return {...state,
        isOffline: true,
        wasOffline: true,
      }
    }
    case APP_BACK_ONLINE:{
      return {...state,
        wasOffline: false,
      }
    }
    case APP_LOADING:{
      return {
        ...state,
        isLoading: true
      }
    }
    case APP_END_LOADING:{
      return {
        ...state,
        isLoading: false
      }
    }
    case APP_CHANGE_LOADING_SCREEN_TEXT: {
      return {
        ...state,
        waitingScreenText: action.payload
      }
    }
    case HUB_CONNECTED: {
      return {
          ...state,
          isConnected: true,
          };
    }
    case HUB_DISCONNECTED:{
        return{
            ...state,
            isConnected: false,
        }
    }
    case SET_USER_TRAPPED_ON_PAGE_URL_PATH: {
        return {
            ...state,
            userTrappedOnPageUrlPath: action.payload,
        }
    }
    case SET_CONTRACT_DONE_DATA:{
      return {
          ...state,
          manualVerificationState: {
            ...state.manualVerificationState,
            contractDone: action.payload,
          }
      }
    }
    case SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE:{
      return {
          ...state,
          manualVerificationState: {
            ...state.manualVerificationState,
            manualVerificationPageHubVerificationState: action.payload.manualVerificationPageVerificationState,
            workFrom: action.payload.workFrom
          }
      }
    }
    case SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION: {
      if(action.payload === true) {
        return {
          ...state,
          manualVerificationState: {
            ...state.manualVerificationState,
            hasClientConsentManualVerification: true,
          }
        }
      }
      else {
        return {
          ...state,
          manualVerificationState: {
            ...state.manualVerificationState,
            hasClientConsentManualVerification: false,
            clientConsentManualVerificationHasError: true,
          }
        }
      }
    }

    case SET_APP_HAS_ERROR: {
      return {
        ...state,
        isAppHasError: true,
      }
    }

    case SET_HUB_CONNECTION_STATUS: {
      return {
        ...state,
        hubConnectionStatus: action.payload
      }
    }

    case SET_USER_EMAIL_FROM_HUB: {
      return {
        ...state,
        userEmailFromHub: action.payload
      }
    }

    case SET_CURRENT_SELECTED_PREDEFINED_PERIOD: {
      return {
         ...state,
         currentSelectedPredefinedPeriod: action.payload,
      }
    }
    case SET_IS_PREDEFINED_PERIODS_AVAILABLE: {
      return {
         ...state,
         IS_PREDEFINED_PERIODS_AVAILABLE: action.payload,
      }
    }

    default: {
      return state;
    }
  }
}
